module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('admin-layout', [_c('div', {
    staticClass: "content",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('h3', [_vm._v("Default values")]), _vm._v(" "), _c('form', {
    staticClass: "form-vertical"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Default Dashboard")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountModel.main_page),
      expression: "accountModel.main_page"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.accountModel, "main_page", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Pick one option")]), _vm._v(" "), _vm._l((_vm.dashboardList), function(choice) {
    return _c('option', {
      domProps: {
        "value": choice.id
      }
    }, [_vm._v(_vm._s(choice.name))])
  })], 2)])])])]), _vm._v(" "), _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-custom",
    on: {
      "click": function($event) {
        return _vm.saveAccount()
      }
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1587fad8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/AccountSettings.vue
// module id = 635
// module chunks = 0